import { render, staticRenderFns } from "./TitleInfo.vue?vue&type=template&id=665fb0a5&scoped=true&"
import script from "./TitleInfo.vue?vue&type=script&lang=js&"
export * from "./TitleInfo.vue?vue&type=script&lang=js&"
import style0 from "./TitleInfo.vue?vue&type=style&index=0&id=665fb0a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fb0a5",
  null
  
)

export default component.exports